import http from "./http";
import { createURI } from "@/utils/string";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    get(planoId, version = undefined) {
        console.assert(typeof planoId === "number");
        return http.get(buildUrlFromLocation(createURI(`/plano/:planoId`, { params: { planoId }, query: { version } })));
    },
    // a raw planogram (the `config` field)
    saveContent(planoId, content) {
        console.assert(content);
        return http.post(buildUrlFromLocation(`/plano/${planoId}/config`), {
            content: cleanConfig(content)
        });
    },
    editNamePlano(planoId, name) {
        return http.post(buildUrlFromLocation(`/plano/${planoId}`), {
            name
        });
    },
    savePlanoAs(planoId, newPlano) {
        return http.post(buildUrlFromLocation("/plano/" + planoId + "/save_as"), newPlano);
    },
    duplicate(planoId, newPlano) {
        return http.post(buildUrlFromLocation("/plano/" + planoId + "/duplicate"), newPlano);
    },
    savePlanoAsTemplate(planoId, template) {
        return http.post(buildUrlFromLocation(`/plano/${planoId}/saveAsTemplate`), template);
    }
};

export function cleanConfig(content) {
    return {
        content: content.content,
        groups: content.groups,
        models: content.models.map(model => {
            if (model.type === "ModuleElement") {
                const { height, id, label, type, width } = model;
                // we voluntarily remove the extra fields to keep only the bare minimum.
                // other fields should be reinserted
                return { height, id, label, type, width };
            }
            return model;
        })
    };
}



// WEBPACK FOOTER //
// ./src/services/plano.js